import { Box, Group, Text } from '@mantine/core'
import { BrandLogo } from '@/components/brand/BrandLogo'
import { useTabAwareNavHandlers } from '@/lib/workspace-tabs-context'

/** Как пункт «Все обращения»: сброс query (проект, фильтр и т.д.) */
const ALL_TICKETS = '/tickets'

export function SidebarBrand({ collapsed }: { collapsed: boolean }) {
  const { onClick, onAuxClick, href } = useTabAwareNavHandlers(ALL_TICKETS)
  return (
    <Box
      component="a"
      href={href}
      onClick={onClick}
      onAuxClick={onAuxClick}
      title="Все обращения"
      style={{
        textDecoration: 'none',
        color: 'inherit',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        minHeight: 0,
      }}
    >
      <Group
        gap={8}
        wrap="nowrap"
        justify={collapsed ? 'center' : 'flex-start'}
        align="center"
        w="100%"
      >
        <Box className="sidebar-brand-mark" style={{ lineHeight: 0, flexShrink: 0 }}>
          <BrandLogo variant="compact" />
        </Box>
        {!collapsed && (
          <Box style={{ minWidth: 0, flex: 1 }}>
            <Text fz="sm" fw={700} lh={1.2} truncate>
              TOIS.TECH
            </Text>
            <Text fz={11} fw={600} c="dimmed" lh={1.2} truncate tt="uppercase" lts={0.06}>
              Servicedesk
            </Text>
          </Box>
        )}
      </Group>
    </Box>
  )
}
